module.exports = __webpack_public_path__ + "7ac21aebf042334aa507b18cfdde9887.png";